import { render, staticRenderFns } from "./ShipmentForm.vue?vue&type=template&id=5eb3436b&"
import script from "./ShipmentForm.vue?vue&type=script&lang=ts&"
export * from "./ShipmentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports